import React from "react";
import "./BcValueCircle.css";

// Shared presentational green circle for Business-Central dollar-value widgets
// (Inventory Over 90, A/R Over 90, ...). Pass a title and the numeric value;
// null value renders a loading ellipsis.
const BcValueCircle = ({ title, value }) => {
  const formatted =
    value == null
      ? "…"
      : Number(value).toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 0,
        });

  return (
    <div className="bcvc-widget">
      <div className="bcvc-circle">
        <span className="bcvc-label">{title}</span>
        <span className="bcvc-value">{formatted}</span>
      </div>
    </div>
  );
};

export default BcValueCircle;
